import { ref, getDownloadURL } from 'firebase/storage'

export const getUrlDaStorage = async (path) => {
    var immagine = await getDownloadURL(ref(storage, path))

    return immagine
}
